import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bl_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPKR = (n) =>
  "Rs. " + Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

export const CATEGORIES = [
  { slug: "bedding", label: "Bedding" },
  { slug: "blankets", label: "Blankets" },
  { slug: "cushion-covers", label: "Cushion Covers / Towels / Pillows" },
  { slug: "curtains", label: "Curtains" },
];

export const BEDDING_TYPES = ["Comforter", "Duvet", "Fitted Sheet", "Bedsheet"];
export const BEDSHEET_SIZES = ["King", "Single"];
export const PILLOW_OPTIONS = [2, 4];
export const CURTAIN_STANDARD_SIZE = "7.5 ft x 4.5 ft";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1b235423-2870-43ca-b9e6-4a44f088b6f4/artifacts/72oaiy9s_WhatsApp%20Image%202026-05-09%20at%202.05.13%20AM.jpeg";
